import { Megaphone } from 'lucide-react';

// Define the structure of a notice
interface NoticeItem {
  id: number;
  title: string;
  date: string;
  content: string | JSX.Element; // Content can be simple string or JSX for more complex formatting
}

// Manually added notices
// You can update this array to add, remove, or modify notices.
const notices: NoticeItem[] = [
  {
    id: 46,
    title: "기능 개선: 입금매칭 추천 주문 직접 변경",
    date: '2026년 10월 06일',
    content: (
      <>
        <p className="mb-2">이제 입금매칭에서 추천된 주문이 맞지 않을 때 다른 주문을 직접 골라 연결할 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>'입금완료 처리' 또는 '확인' 버튼 옆 '다른 주문' 버튼을 누르면 미지정 주문 목록이 열립니다.</li>
          <li>닉네임으로 검색해 주문을 찾을 수 있습니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 45,
    title: "기능 추가: 배송엑셀 정산서 순서로 정렬",
    date: '2026년 10월 06일',
    content: (
      <>
        <p className="mb-2">이제 배송엑셀을 정산서에 등록된 순서대로 정렬할 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>배송엑셀 표의 '순서' 칸 제목을 누르고 '정산서 순서'를 선택하면 됩니다.</li>
          <li>화면과 엑셀 다운로드 모두 같은 순서로 정렬되며, 선택한 순서는 저장됩니다.</li>
          <li>기본값은 기존과 같은 '입력 순서'입니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 44,
    title: "기능 개선: 오늘얼마 많이 주문된 상품 월별 확인",
    date: '2026년 09월 29일',
    content: (
      <>
        <p className="mb-2">이제 오늘얼마의 '많이 주문된 상품'을 달력에서 선택한 달 기준으로 확인할 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>선택한 달에 가장 많이 주문된 상품 상위 10개를 수량 순으로 보여줍니다.</li>
          <li>기존에는 최근 90일 기준으로만 표시되었습니다.</li>
        </ul>
        <p className="mb-2">프리미엄 플랜에서 사용할 수 있습니다.</p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 43,
    title: "기능 추가: 대시보드 고객별 구매 총액·거파 고객 명단",
    date: '2026년 09월 16일',
    content: (
      <>
        <p className="mb-2">이제 대시보드에서 고객별 월 구매 총액을 확인할 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>이번 달과 지난 2개월 중 한 달을 골라 고객별 건수와 금액을 볼 수 있습니다.</li>
          <li>입금 완료·출고 완료 주문의 상품 금액 기준이며, 배송비는 제외됩니다.</li>
          <li>닉네임 검색과 금액순·건수순·닉네임순 정렬을 지원합니다.</li>
        </ul>
        <p className="mb-2">고객별 구매 총액은 스탠다드 플랜 이상에서 사용할 수 있습니다.</p>
        <p className="mb-2">등록한 거파 고객 명단도 대시보드에서 함께 확인할 수 있습니다.</p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 42,
    title: "기능 추가: 입금매칭 부분입금 관리",
    date: '2026년 07월 25일',
    content: (
      <>
        <p className="mb-2">이제 입금매칭 화면의 '부분입금' 영역에서 아직 다 받지 못한 주문을 한곳에서 관리할 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>입금매칭으로 입금 완료된 주문에 상품이 추가되거나 배송비가 바뀌어 받을 금액이 늘어나면, 자동으로 '부분 입금'으로 바뀌어 이곳에 모입니다.</li>
          <li>주문마다 받은 금액과 남은 금액이 표시됩니다.</li>
          <li>남은 금액이 모두 들어오면 '입금 완료 처리' 버튼으로 마무리할 수 있습니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 41,
    title: "기능 추가: 거파 고객 등록",
    date: '2026년 07월 23일',
    content: (
      <>
        <p className="mb-2">이제 거래 파기 고객을 '거파 고객'으로 등록해두고, 다음 주문 때 바로 알아볼 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>정산서 화면에서 고객을 선택한 뒤 '거파' 버튼으로 사유와 함께 등록할 수 있습니다.</li>
          <li>등록한 고객은 닉네임 옆에 🚫 표시가 붙고, 선택하면 경고가 표시됩니다.</li>
          <li>'전체 명단 보기'에서 명단을 확인하고 해제할 수 있습니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 40,
    title: "새로운 기능: '재고관리' 출시 안내",
    date: '2026년 07월 17일',
    content: (
      <>
        <p className="mb-2">상품을 등록해두면 정산서 주문이 입금 완료될 때 재고가 자동으로 차감되는 '재고관리' 기능이 새롭게 추가되었습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>입금 완료·출고 완료 처리 시 재고가 자동으로 차감되고, 입금 전 상태로 되돌리면 다시 채워집니다.</li>
          <li>최근 정산서에 나온 상품을 '재고 등록 추천 상품'에서 바로 등록하거나, 엑셀로 한 번에 등록할 수 있습니다.</li>
          <li>'입출고 내역'에서 입고·출고·조정·주문 차감 기록을 확인할 수 있습니다.</li>
          <li>정산서 화면에서 재고 수량을 보며 내 상품을 바로 담을 수 있습니다.</li>
          <li>상품 등록 전에 이미 입금 완료된 주문은 재고에서 차감되지 않습니다.</li>
        </ul>
        <p className="mb-2">상단 메뉴의 '재고관리'에서 시작할 수 있습니다.</p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 39,
    title: "기능 추가: 다른 배송비 저장 및 적용",
    date: '2026년 07월 12일',
    content: (
      <>
        <p className="mb-2">이제 기본 배송비 외에 자주 쓰는 배송비를 최대 4개까지 저장해두고, 버튼 한 번으로 적용할 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>정산서 화면의 '배송/결제 설정' → '다른 배송비 추가'에서 등록할 수 있습니다.</li>
          <li>저장한 금액은 '배송비' 선택 버튼에 함께 표시됩니다.</li>
          <li>입금매칭에서 주문 금액과 다른 배송비의 합이 입금 금액과 일치하면 처리 제안이 표시됩니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 38,
    title: "기능 추가: 대시보드 닉네임·상품명 통합 검색",
    date: '2026년 07월 10일',
    content: (
      <>
        <p className="mb-2">대시보드의 주문 검색이 통합 검색으로 업그레이드되었습니다. 검색창 하나에서 고객 닉네임은 물론 상품명으로도 주문을 찾을 수 있습니다.</p>
        <p className="mb-2">검색어를 입력하면 '고객'과 '상품' 제안이 함께 표시됩니다.</p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 37,
    title: "새로운 기능: '입금매칭' 출시 안내",
    date: '2026년 07월 05일',
    content: (
      <>
        <p className="mb-2">입금 확인을 자동으로 해주는 '입금매칭' 기능이 새롭게 추가되었습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>계좌를 한 번 연동하면, 입금 문자가 올 때마다 자동으로 주문과 매칭됩니다.</li>
          <li>매칭된 입금은 클릭 한 번으로 정산서 '입금 완료' 처리까지 이어집니다.</li>
          <li>지원 은행: 우리은행, KB국민은행, 신한은행, 하나은행, NH농협은행, IBK기업은행</li>
        </ul>
        <p className="mb-2">상단 메뉴의 '입금매칭'에서 1분 만에 연동할 수 있습니다.</p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 36,
    title: "기능 개선: 주문상태 변경 / 배송 정보 입력이 더 빨라졌어요",
    date: '2026년 05월 07일',
    content: (
      <>
        <p className="mb-2">사용 중 느려졌던 부분을 개선했습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>킵, 입금 완료, 출고 완료 등 주문 상태를 바꿀 때 더 빠르게 반영됩니다.</li>
          <li>배송 정보 입력창을 열고 저장하는 속도도 더 빨라졌습니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 35,
    title: "기능 추가: 메시지 템플릿 여러 개 만들기 (최대 3개)",
    date: '2026년 05월 07일',
    content: (
      <>
        <p className="mb-2">이제 메시지 템플릿을 최대 3개까지 만들어두고, 상황에 맞게 탭을 눌러 바꿔가며 사용할 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>탭 옆 + 버튼으로 새 템플릿을 추가하고, 🗑 버튼으로 삭제할 수 있습니다.</li>
          <li>탭의 ✏️ 버튼을 누르면 템플릿 이름을 바로 수정할 수 있습니다.</li>
          <li>입력하신 내용은 저장 버튼을 누르지 않아도 자동으로 저장됩니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 34,
    title: "기능 개선: 최근 추가한 상품 저장 개수 1000개에서 2000개로 증가",
    date: '2026년 03월 25일',
    content: (
      <>
        <p className="mb-2"> 최근 추가한 상품 저장 개수가 1000개에서 2000개로 증가되었습니다. </p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 33,
    title: "기능 개선: 최근 추가한 상품 저장 개수 500개에서 1000개로 증가",
    date: '2026년 03월 15일',
    content: (
      <>
        <p className="mb-2"> 최근 추가한 상품 저장 개수가 500개에서 1000개로 증가되었습니다. </p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 32,
    title: "기능 추가: 배송 엑셀 페이지의 택배사 양식 설정 기능",
    date: '2026년 03월 12일',
    content: (
      <>
        <p className="mb-2">
          이제 사용하시는 택배사의 엑셀 양식을 업로드하면, 셀러헬퍼의 데이터와 맞는 컬럼을 자동으로 매핑하여 해당 양식에 맞는 엑셀 파일을 다운로드할 수 있습니다.
        </p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>배송엑셀 페이지의 다운로드 버튼 → '내 택배사 양식 설정하기'에서 양식을 등록할 수 있습니다.</li>
          <li>한 번 등록하면 이후 다운로드 시 설정해둔 택배사 양식으로 바로 내보낼 수 있습니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 31,
    title: "기능 추가: 자동 정리 고객 배송정보 자동 채움",
    date: '2025년 12월 18일',
    content: (
      <>
        <p className="mb-2">
          정산서 화면에서 배송 정보 입력 시, 닉네임에 대한 과거 자동 정리된 배송 정보가 있으면 이름/전화번호/주소를 자동으로 채워줍니다.
        </p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>닉네임이 '고객', '고객 닉네임'인 경우는 자동 채움 없이 기본값만 표시합니다.</li>
          <li>자동 채움 시 각 항목 옆에 '자동 채움' 배지가 표시됩니다.</li>
        </ul>
        <p>필요 시 언제든 수정해 저장할 수 있습니다.</p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 30,
    title: "기능 개선: 정산서 화면 고객 삭제 확인 다이얼로그 추가",
    date: '2025년 12월 05일',
    content: (
      <>
        <p className="mb-2"> 정산서 화면에서 고객을 삭제할 때 삭제 확인 다이얼로그가 추가되었습니다. </p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 29,
    title: "기능 개선: 최근 추가한 상품 저장 개수 200개에서 500개로 증가",
    date: '2025년 11월 13일',
    content: (
      <>
        <p className="mb-2"> 최근 추가한 상품 저장 개수가 200개에서 500개로 증가되었습니다. </p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 28,
    title: "기능 추가: 제주/산간 지역 배송비 설정 및 적용, 무료 배송비 적용 버튼 추가",
    date: '2025년 11월 13일',
    content: (
      <>
        <p className="mb-2"> 제주/산간 지역 배송비 설정 및 적용이 가능해졌습니다. </p>
        <p className="mb-2"> 또한, 이제 버튼으로 무료 배송비 적용이 가능해졌습니다. </p>
        <p>감사합니다.</p>
      </>
    )
  },
  {
    id: 27,
    title: "기능 개선: 오늘얼마 페이지 성능 개선",
    date: '2025년 10월 28일',
    content: (
      <>
        <p className="mb-2"> 오늘얼마 페이지의 로딩 속도가 개선되었습니다. </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 26,
    title: "기능 추가: 배송 엑셀 킵 주문 다운로드 기능",
    date: '2025년 10월 20일',
    content: (
      <>
        <p className="mb-2"> 배송 엑셀 킵 주문 다운로드 기능이 추가되었습니다. </p>
        <p className="mb-2"> 최근 2주 내 킵 주문 내역을 엑셀 파일로 다운로드 할 수 있습니다. </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 25,
    title: "기능 추가: 주문 날짜 변경 기능",
    date: '2025년 09월 30일',
    content: (
      <>
        <p className="mb-2"> 주문 날짜 변경 기능이 추가되었습니다. </p>
        <p className="mb-2"> 정산서의 주문 날짜를 변경할 수 있습니다. </p>
        <p className="mb-2"> 정산서의 주문 날짜 변경 시, 정산서 화면에서 배송 정보 입력 버튼을 통해 배송엑셀 데이터를 추가했던 경우, 배송 엑셀의 날짜도 동일하게 변경됩니다. </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 24,
    title: "기능 개선: 대시보드 로딩 속도 개선",
    date: '2025년 09월 24일',
    content: (
      <>
        <p className="mb-2"> 주문 내역 조회 관련 최적화를 진행하여, 대시보드 로딩 속도가 개선되었습니다. </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 23,
    title: "기능 개선: 정산서 화면 디자인 개선",
    date: '2025년 09월 17일',
    content: (
      <>
        <p className="mb-2"> 합배송 가능 주문 내역 패널이 합배송 가능한 주문들이 존재할 때에만 나타나며, 오른쪽에서 나타나도록 개선되었습니다.</p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 22,
    title: "기능 개선: 정산서 화면 디자인 개선",
    date: '2025년 09월 15일',
    content: (
      <>
        <p className="mb-2">정산서 화면 디자인이 개선되었습니다.</p>
        <p className="mb-2">고객이 많을 경우 새로운 고객을 추가하기 위해 스크롤을 내려야 하던 불편함이 해소되었습니다.</p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 21,
    title: "기능 추가: 정산서 화면에서 배송 정보 입력/수정",
    date: '2025년 08월 10일',
    content: (
      <>
        <p className="mb-2">이제 정산서 화면에서도 고객별 배송 정보를 바로 입력할 수 있습니다.</p>
        <ul className="list-disc list-inside space-y-1 mb-2">
          <li>‘입금 완료’ 주문에는 ‘배송 정보 입력’ 버튼이 표시됩니다.</li>
          <li>저장 시 ‘배송엑셀’ 페이지에 자동으로 추가됩니다.</li>
        </ul>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 20,
    title: "새로운 기능: '대시보드' 출시 안내",
    date: '2025년 08월 06일',
    content: (
      <>
        <p className="mb-2">
          주문 현황을 한눈에 파악하고 고객 주문을 쉽게 관리할 수 있는 '대시보드' 기능이 새롭게 추가되었습니다.
        </p>
        <p className="mb-2">
          대시보드를 통해 고객 닉네임으로 최근 30일간의 주문 내역을 빠르게 검색하고, '킵', '입금 완료', '출고 완료' 등 주문 상태별 현황을 요약해서 볼 수 있습니다.
        </p>
        <p>이제 더 효율적으로 고객 주문을 관리해보세요.</p>
      </>
    ),
  },
  {
    id: 19,
    title: '기능 개선: 정산서 - 다운로드 및 필터링 기능',
    date: '2025년 08월 01일',
    content: (
      <>
        <p className="mb-2">정산서 페이지의 기능이 아래와 같이 개선되었습니다.</p>
        <ul className="list-disc list-inside space-y-1">
          <li>입금완료 정산서 목록 다운로드 시, 개별 상품 금액도 함께 표시됩니다.</li>
          <li>일괄 처리 모드에서 엑셀 다운로드 기능이 추가되었습니다.</li>
          <li>일괄 처리 모드에서 킵 여부 필터링 기능이 추가되었습니다.</li>
        </ul>
      </>
    ),
  },
  {
    id: 18,
    title: '기능 개선: 정산서 - 상품 수량 수정 기능',
    date: '2025년 07월 25일',
    content: '정산서 페이지에서 이미 추가된 상품의 수량을 수정할 수 있도록 개선되었습니다.',
  },
  {
    id: 17,
    title: '기능 개선: 정산서 - 최근 추가한 상품 200개로 증가',
    date: '2025년 07월 15일',
    content: '정산서 페이지에서 최근 추가한 상품을 100개에서 200개로 더 많이 볼 수 있도록 개선되었습니다.',
  },
  {
    id: 1,
    title: '셀러 헬퍼 서비스 정식 오픈!',
    date: '2025년 03월 18일',
    content: (
      <>
        <p className="mb-2">안녕하세요, 셀러 헬퍼입니다.</p>
        <p className="mb-2">드디어 셀러 헬퍼 서비스가 정식으로 오픈되었습니다! 🎉</p>
        <p className="mb-2">
          셀러 헬퍼는 판매자 여러분의 반복적인 업무를 자동화하고, 더 중요한 일에 집중하실 수 있도록 돕기 위해 만들어졌습니다.
        </p>
        <p className="mb-2">앞으로 많은 관심과 사랑 부탁드립니다.</p>
        <p className="mb-2">감사합니다.</p>
      </>
    ),
  },
  {
    id: 2,
    title: '새로운 기능: \'배송엑셀\' 출시 안내',
    date: '2025년 05월 25일',
    content: (
      <>
        <p className="mb-2">
          고객으로부터 온 답장을 붙여넣기만 하면 이름, 전화번호, 주소, 닉네임이 분류되고 엑셀 파일로 다운로드까지 할 수 있는 '배송엑셀' 기능이 새롭게 추가되었습니다.'
        </p>
        <p className="mb-2">
          일일이 붙여넣고 정리할 필요 없이 시간을 절약해보세요.
        </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 3,
    title: '새로운 기능: \'오늘얼마\' 출시 안내',
    date: '2025년 05월 27일',
    content: (
      <>
        <p className="mb-2">
          판매자 여러분의 일일 매출 및 판매 현황을 한눈에 파악할 수 있는 '오늘 얼마?' 기능이 새롭게 추가되었습니다.
        </p>
        <p className="mb-2">
          복잡한 계산 없이 간편하게 오늘의 성과를 확인하고, 판매 전략을 세우는 데 활용해 보세요.
        </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 4,
    title: '[중요] 셀러헬퍼 구독제 전환 안내',
    date: '2025년 05월 28일',
    content: (
      <>
        <p className="mb-2">
          안녕하세요, 셀러헬퍼를 이용해주시는 셀러 여러분.
        </p>
        <p className="mb-2">
          그동안 저희 셀러헬퍼를 아껴주시고 사랑해 주셔서 진심으로 감사드립니다.
        </p>
        <p className="mb-2">
          다름이 아니라, 그동안 완전 무료로 제공되었던 셀러헬퍼 서비스가 부득이하게 유료 구독 서비스로 전환될 예정임을 안내드립니다.
        </p>
        <p className="mb-2">
          지속적으로 증가하는 서버 유지 비용과 안정적인 서비스 운영을 위해 여러 방안을 고민한 끝에 내린 결정으로, 여러분의 넓은 이해와 양해를 부탁드리겠습니다.
        </p>
        <p className="mb-2">
          저희는 앞으로도 더욱 좋은 기능과 가치 있는 서비스를 제공하여, 이번 결정에 대한 여러분의 아쉬움이 충분히 보상될 수 있도록 최선을 다하겠습니다.
        </p>
        <p className="mb-2">
          다시 한번 너그러운 이해와 변함없는 성원 부탁드립니다.
        </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 5,
    title: '기능 개선: 정산서-메시지 템플릿',
    date: '2025년 06월 04일',
    content: '정산서별로 설정한 고객 닉네임이 메시지에 자동입력되도록 개선되었습니다.',
  },
  {
    id: 6,
    title: '기능 개선: 정산서-메시지 템플릿',
    date: '2025년 06월 13일',
    content: (
      <>
        <p className="mb-2">
          06월 04일에 정산서별로 설정한 고객 닉네임이 메시지에 자동입력되도록 개선되었던 적이 있습니다.
        </p>
        <p className="mb-2">
          그러나 고객 추가 없이 사용을 하는 유저분들이 많으셔서 자동입력되지 않는 것을 기본으로 하였습니다.
        </p>
        <p className="mb-2">
          자동입력이 되길 원하시는 분들은 정산서 페이지의 메시지 정보-템플릿 편집에 가셔서 [고객 닉네임]을 추가해주시기 바랍니다.
        </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 7,
    title: '기능 추가: 정산서-킵 기능, 주문상태 관리 기능',
    date: '2025년 06월 18일',
    content: (
      <>
        <p className="mb-2">
          정산서에 킵 기능과 주문상태 관리 기능이 추가되었습니다.
        </p>
        <p className="mb-2">
          정산서에 킵 여부 체크를 할 수 있고, 추후 동일한 닉네임에 대한 정산서를 만들면 킵 주문 내역을 볼 수 있습니다.
        </p>
        <p className="mb-2">
          킵을 받지 않는 셀러 분들도 입금 완료 상태로 설정해놓은 기존 주문 내역을 볼 수 있습니다.
        </p>
        <p className="mb-2">
          또한, 기존에 킵 또는 입금 완료 상태인 정산서가 있다면 새로운 정산서에는 배송비를 0원으로 적용하는 기능도 추가되었습니다.
        </p>
        <p>감사합니다.</p>
      </>
    ),
  },
  {
    id: 8,
    title: '기능 추가: 배송엑셀-컬럼 추가/제외 기능',
    date: '2025년 06월 19일',
    content: (
      <>
        <p className="mb-2">
          배송 엑셀 자동 정리 및 다운로드시, 닉네임과 상품명 컬럼을 추가 혹은 제외할 수 있게 되었습니다.
        </p>
        <p className="mb-2">
          감사합니다.
        </p>
      </>
    ),
  },
  {
    id: 9,
    title: '배송엑셀 페이지 매출 기준 변경',
    date: '2025년 06월 19일',
    content: (
      <>
        <p className="mb-2"> 기존에는 동일 날짜, 동일 닉네임 기준으로 정산서와 배송 엑셀 데이터가 모두 존재할 때만 매출로 연동되었습니다. </p>
        <p className="mb-2"> 이제 정산서 페이지에 주문 상태 관리 기능이 추가되어, <strong>입금 완료</strong> 또는 <strong>출고 완료</strong> 상태인 주문은 자동으로 매출에 반영됩니다. </p>
      </>
    ),
  },
  {
    id: 10,
    title: '기능 개선: 정산서-킵 기능 2주에서 30일로 확대',
    date: '2025년 06월 20일',
    content: (
      <>
        <p className="mb-2"> 기존에는 최근 2주간의 킵/입금완료 주문 한정해서 조회 가능하였으나 30일로 확대되었습니다. </p>
        <p className="mb-2"> 감사합니다. </p>
      </>
    ),
  },
  {
    id: 11,
    title: '기능 추가: 정산서 - 일괄 출고완료 처리 기능 추가',
    date: '2025년 06월 25일',
    content: (
      <>
        <p className="mb-2"> 최신 주문 출고완료 처리시 이전 킵/입금완료 주문들도 선택하여 일괄 출고완료 처리 가능한 기능이 개발되었습니다. </p>
        <p className="mb-2"> 감사합니다. </p>
      </>
    ),
  },
  {
    id: 12,
    title: '기능 추가: 정산서 - 고객 닉네임 자동완성',
    date: '2025년 06월 27일',
    content: (
      <>
        <p className="mb-2"> 주문 내역이 존재하는 고객인 경우 닉네임 자동완성 기능이 개발되었습니다. </p>
        <p className="mb-2"> 감사합니다. </p>
      </>
    ),
  },
  {
    id: 13,
    title: '기능 추가: 정산서 - 일괄 처리 모드',
    date: '2025년 06월 30일',
    content: (
      <>
        <p className="mb-2"> 일괄 처리 모드를 통해 주문들의 일괄 상태 변경 / 킵이 가능해졌습니다. </p>
        <p className="mb-2"> 감사합니다. </p>
      </>
    ),
  },
  {
    id: 14,
    title: '기능 개선: 정산서 - 일괄 처리 모드',
    date: '2025년 07월 07일',
    content: (
      <>
        <p className="mb-2"> 일괄 처리 모드 시 고객별 총 구매액을 볼 수 있으며 여러 기준별 정렬하여 조회가 가능해졌습니다. </p>
        <p className="mb-2"> 감사합니다. </p>
      </>
    ),
  },
  {
    id: 15,
    title: '기능 개선: 정산서 - 최근 추가한 상품 빠르게 추가 기능',
    date: '2025년 07월 09일',
    content: (
      <>
        <p className="mb-2"> 기존의 최근 추가한 상품들은 데이터로 저장하고 있지 않았으나, 최근 100개의 상품까지 저장될 수 있도록 하였습니다.</p>
        <p className="mb-2"> 감사합니다. </p>
      </>
    ),
  },
  {
    id: 16,
    title: '기능 추가: 정산서 - 입금완료 상태 주문 정산서 엑셀 다운로드',
    date: '2025년 07월 09일',
    content: (
      <>
        <p className="mb-2"> 입금완료 상태인 주문들의 정산서 목록을 일괄로 엑셀 다운로드 가능하게 하였습니다.</p>
        <p className="mb-2"> 감사합니다. </p>
      </>
    ),
  },
  {
    id: 17,
    title: '기능 추가: 정산서 - 입금완료 상태 주문 정산서 엑셀 다운로드',
    date: '2025년 07월 09일',
    content: (
      <>
        <p className="mb-2"> 입금완료 상태인 주문들의 정산서 목록을 일괄로 엑셀 다운로드 가능하게 하였습니다.</p>
        <p className="mb-2"> 감사합니다. </p>
      </>
    ),
  }
];

export default function NoticePage() {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto p-5 md:p-8">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800 flex items-center">
            <Megaphone className="w-8 h-8 mr-3 text-indigo-600" />
            공지사항
          </h1>
          <p className="text-gray-600 mt-2">셀러 헬퍼의 새로운 소식들을 확인하세요.</p>
          <p className="text-gray-600 mt-2">궁금한 점은 언제든 문의주세요.</p>
        </header>

        {notices.length > 0 ? (
          <div className="space-y-6">
            {notices.sort((a,b) => b.id - a.id).map((notice) => ( // Sort by ID descending to show newest first
              <div key={notice.id} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">{notice.title}</h2>
                <p className="text-sm text-gray-500 mb-4">{notice.date}</p>
                <div className="text-gray-700 leading-relaxed prose prose-sm max-w-none">
                  {typeof notice.content === 'string' ? <p>{notice.content}</p> : notice.content}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <Megaphone className="w-16 h-16 mx-auto text-gray-400 mb-4" />
            <p className="text-xl text-gray-500">등록된 공지사항이 없습니다.</p>
          </div>
        )}
      </div>
    </div>
  );
}